// Re-use the no-op auth plugin.
import noopAuth from '../noop'

import { anonymousConnect, anonymousDisconnect } from './sagas'
import { extendSubscription } from '../oldLink/sagas'
import { mergeValues } from '../../common/utils'

// Parse and/or Validate
import { enums, validation as v8n, parse } from '../../../src/common/validation'

/**
 * Configuration options for the CallMe Authentication feature.
 * @public
 * @name config.authentication
 * @memberof config
 * @instance
 * @param {Object}  authentication Authentication configs.
 * @param {Object}  authentication.subscription
 * @param {string} [authentication.subscription.protocol='https'] Protocol to be used for subscription requests.
 * @param {string}  authentication.subscription.server Server to be used for subscription requests.
 * @param {Number} [authentication.subscription.port=443] Port to be used for subscription requests.
 * @param {Array}  [authentication.subscription.service] Services to subscribe to for notifications.
 * @param {Object}  authentication.websocket
 * @param {string} [authentication.websocket.protocol='wss'] Protocol to be used for websocket notifications.
 * @param {string}  authentication.websocket.server Server to be used for websocket notifications.
 * @param {Number} [authentication.websocket.port=443] Port to be used for websocket notifications.
 */

export const defaultOptions = {
  subscription: {
    protocol: 'https',
    server: null,
    port: 443,
    version: '1', // not documented, but important
    service: []
  },
  websocket: {
    protocol: 'wss',
    server: null,
    port: 443
  }
}

// config validation
const v8nValidation = v8n.schema({
  subscription: v8n.schema({
    protocol: enums(['http', 'https']),
    server: v8n.string(),
    port: v8n.positive(),
    version: enums(['1']), // not documented, but important
    service: v8n.array().every.string()
  }),
  websocket: v8n.schema({
    protocol: v8n.string(),
    server: v8n.string(),
    port: v8n.positive()
  })
})
const parseOptions = parse('authentication', v8nValidation)

/**
 * Auth plugin factory for callMe scenarios.
 * @method callMeAuth
 * @param  {Object} options Configuration options for authentication. See above.
 * @return {Object} A callMe authentication plugin.
 */
export default function callMeAuth (options = {}) {
  options = mergeValues(defaultOptions, options)
  parseOptions(options)

  // Use the no-op auth plugin as a basis.
  const authComponents = noopAuth(options)

  // Add in the sagas.
  authComponents.sagas = [anonymousConnect, anonymousDisconnect, extendSubscription]

  return authComponents
}
